import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { useSite } from "../context/SiteContext";
import PageHero from "../components/PageHero";
import AccommodationCard from "../components/AccommodationCard";
import { BocauxTeaser } from "../components/BocauxTeaser";
import BookingDialog from "../components/BookingDialog";
import Reveal from "../components/Reveal";
import { BikeRental } from "../components/BikeRental";
import { MapPin } from "lucide-react";

const NEARBY = [
  { name: "Dol-de-Bretagne", time: "5 min" },
  { name: "Mont-Saint-Michel", time: "30 min" },
  { name: "Saint-Malo", time: "25 min" },
  { name: "Cancale", time: "25 min" },
  { name: "Dinan", time: "30 min" },
];

export default function GitesPage() {
  const { t } = useI18n();
  const { settings } = useSite();
  const [items, setItems] = useState([]);
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    api.get("/accommodations", { params: { type: "gite" } }).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageHero title={t("gitesPage.title")} subtitle={t("hero.subtitle")} image={settings.gallery?.[8] || settings.hero_image} crumb={t("nav.gites")} />
      <section className="py-16 lg:py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center mb-14">
          <Reveal><p className="text-ink-600 font-body text-lg leading-relaxed">{t("gitesPage.intro")}</p></Reveal>
        </div>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((a, i) => (
            <Reveal key={a.id} delay={(i % 3) * 100} className="h-full"><AccommodationCard item={a} onBook={setBooking} /></Reveal>
          ))}
        </div>
      </section>

      {/* LES BOCAUX — à emporter uniquement pour les gîtes */}
      <BocauxTeaser takeawayOnly className="bg-beige/60" />

      <section className="py-16 lg:py-24 bg-white" data-testid="gites-seo-section">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h2 className="font-heading text-3xl sm:text-4xl text-ink-900 mb-6">{t("gitesPage.seoTitle")}</h2>
            <div className="space-y-4 text-ink-600 font-body leading-relaxed">
              <p>{t("gitesPage.seoP1")}</p>
              <p>{t("gitesPage.seoP2")}</p>
              <p>{t("gitesPage.seoP3")}</p>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <h3 className="font-heading text-xl text-ink-900 mt-10 mb-4">{t("gitesPage.nearbyTitle")}</h3>
            <div className="flex flex-wrap gap-2.5">
              {NEARBY.map((n) => (
                <span key={n.name} className="inline-flex items-center gap-1.5 rounded-full bg-brand-50 text-brand px-4 py-2 text-sm font-medium">
                  <MapPin size={14} strokeWidth={1.75} /> {n.name} · {n.time}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <BikeRental dark />
      <BookingDialog item={booking} open={!!booking} onOpenChange={(v) => !v && setBooking(null)} />
    </div>
  );
}
